<app-banner></app-banner>
<div class="container-fluid">
  <div class="catogeries">
    <h2 class="pt-5">
      {{ "our categories" | translate }}
    </h2>
    <div class="row">
      <div class="col-md-4 col-12 outer-div text-center"  *ngFor="let item of categories">
        <div
          class="category inner-div"
          [routerLink]="'/products/' + item.id"
          [ngStyle]="{ 'background-image': 'url(' + item.image + ')' }"
        >
          <div>
            <h3>{{ item.name }}</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-scroll-to-top></app-scroll-to-top>
